import * as api from '../../service/getData'
import COS from 'cos-js-sdk-v5'
import Vue from 'vue'
const UploadFile = {}

UploadFile.upload = async (name, file, callback, errorCallback) => {
  console.log(file)
  let data = await api.getTxToken()
  if (data.status !== 200) return
  data = data.data
  let credentials = data && data.credentials

  const cos = new COS({
    UseAccelerate: true,
    getAuthorization: (options, callback) => {
      callback({
        TmpSecretId: credentials.tmpSecretId,
        TmpSecretKey: credentials.tmpSecretKey,
        SecurityToken: credentials.sessionToken,
        ExpiredTime: data.expiredTime,
        StartTime: data.startTime
      })
    }
  })
  let keyName = 'asset/' + new Date().getTime() + '_' + name
  cos.uploadFile(
    {
      Bucket: 'jojoworld-1323727948' /* 存储桶 */,
      Region: 'ap-singapore' /* 存储桶所在地域，必须字段 */,
      Key: keyName/* 文件名 */,
      // StorageClass: 'STANDARD', // 上传模式, 标准模式
      Body: file, // 上传文件对象,
      CacheControl: 'no-cache'
    },
    (err, data) => {
      // 上传成功之后
      if (err) {
        Vue.$prompt.error(err)
        if (errorCallback) {
          errorCallback()
        }
        return
      }
      if (data.statusCode === 200) {
        callback('https://jojoworld-1323727948.cos.accelerate.myqcloud.com/' + keyName)
      }
    }
  )
}
export default UploadFile



// WEBPACK FOOTER //
// ./src/plugins/upload/upload.js